import { render, staticRenderFns } from "./CoreConfigForm.vue?vue&type=template&id=7f1c1853&scoped=true"
import script from "./CoreConfigForm.vue?vue&type=script&lang=js"
export * from "./CoreConfigForm.vue?vue&type=script&lang=js"
import style0 from "./CoreConfigForm.vue?vue&type=style&index=0&id=7f1c1853&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1c1853",
  null
  
)

export default component.exports